import { useState } from 'react';
import { useSeriesData } from './useSeriesData';

export function useExpandableRows() {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const [loadingRows, setLoadingRows] = useState<Set<string>>(new Set());
  const [errorRows, setErrorRows] = useState<Record<string, string>>({});
  
  const { seriesData, fetchSeriesData, updateSeriesData } = useSeriesData();

  const isExpanded = (rowId: string) => expandedRows.has(rowId);
  const isLoading = (rowId: string) => loadingRows.has(rowId);
  
  const toggleRow = async (rowId: string, studyInstanceUID: string) => {
    if (isExpanded(rowId)) {
      setExpandedRows((prev) => {
        const newSet = new Set(prev);
        newSet.delete(rowId);
        return newSet;
      });
    } else {
      setExpandedRows((prev) => new Set(prev).add(rowId));
      if (!seriesData[rowId]) {
        setLoadingRows((prev) => new Set(prev).add(rowId));
        
        try {
          const series = await fetchSeriesData(rowId, studyInstanceUID);
          updateSeriesData(rowId, series);
        } catch (err: any) {
          console.error(err);
          setErrorRows((prev) => ({
            ...prev,
            [rowId]: err.message || 'Failed to load series data',
          }));
        } finally {
          setLoadingRows((prev) => {
            const newSet = new Set(prev);
            newSet.delete(rowId);
            return newSet;
          });
        }
      }
    }
  };

  return {
    expandedRows,
    loadingRows,
    errorRows,
    seriesData,
    isExpanded,
    isLoading,
    toggleRow
  };
}